__turbopack_context__.v({
  "aofLogo": "productDescription-module-scss-module__a2rdTW__aofLogo",
  "background": "productDescription-module-scss-module__a2rdTW__background",
  "contact": "productDescription-module-scss-module__a2rdTW__contact",
  "content": "productDescription-module-scss-module__a2rdTW__content",
  "cta": "productDescription-module-scss-module__a2rdTW__cta",
  "ctaSecond": "productDescription-module-scss-module__a2rdTW__ctaSecond",
  "darkTheme": "productDescription-module-scss-module__a2rdTW__darkTheme",
  "header": "productDescription-module-scss-module__a2rdTW__header",
  "lcLogo": "productDescription-module-scss-module__a2rdTW__lcLogo",
  "plusLogo": "productDescription-module-scss-module__a2rdTW__plusLogo",
  "productDescription": "productDescription-module-scss-module__a2rdTW__productDescription",
});
